// frontend/shared-ui/src/forms/schemas/puller.js
export default {
    slug: 'puller',
    label: 'Cable Pullers',
    defaultUnit: 'pcs',
    costDefaults: {
        avgVolumeCbm: 0.05,
        suggestedMarkupPct: 30,
        freightSensitivity: 'high',
        note: 'Long coiled pullers 0.025–0.077 CBM depending on length',
    },

    groups: [
        {
            id: 'basic',
            label: 'Basic',
            columns: 2,
            fields: [
                { key: 'cableDiameter_mm', label: 'Cable Diameter Capacity', type: 'number', unit: 'mm', required: true },
                { key: 'length_m', label: 'Puller Length', type: 'number', unit: 'm', required: true },
                { key: 'material', label: 'Material', type: 'select', options: ['Steel', 'Nylon', 'Fiberglass', 'Carbon Fiber'] },
            ],
        },
    ],
    buildSku(v) {
        const parts = ['PULL', v.length_m ? `${v.length_m}M` : '', v.cableDiameter_mm ? `${v.cableDiameter_mm}MM` : ''];
        return parts.filter(Boolean).join('-').toUpperCase();
    },
    buildName(v) {
        const bits = [];
        if (v.length_m) bits.push(`${v.length_m}m`);
        if (v.cableDiameter_mm) bits.push(`${v.cableDiameter_mm}mm`);
        bits.push('Puller');
        if (v.material) bits.push(v.material);
        return bits.join(' ');
    },
    attributeSchema: [
        { key: 'cableDiameter_mm', label: 'Cable Diameter', unit: 'mm' },
        { key: 'length_m', label: 'Length', unit: 'm' },
        { key: 'material', label: 'Material' },
    ],
};